import React, { useEffect, useRef, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { apiRequest } from "../../apiServices/allApi";

const AdminKyc = () => {
  const history = useHistory();
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);

  const [userid, setUserId] = useState("");
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Number, setNumber] = useState("");
  const [DOB, setDob] = useState("");
  const [submitProcess, setProcess] = useState(false);
  const [statusModal, setStatusModal] = useState({
    show: false,
    title: "",
    message: "",
    isSuccess: false,
  });

  const aadharProcess = useRef(false);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }
  }, [history]);

  const handleFrontPhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFrontLoaded(file);
      setFrontPreview(URL.createObjectURL(file));
    }
  };

  const handleBackPhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackLoaded(file);
      setBackPreview(URL.createObjectURL(file));
    }
  };

  const removeFrontPhoto = (e) => {
    e.stopPropagation();
    setFrontLoaded(null);
    setFrontPreview(null);
  };

  const removeBackPhoto = (e) => {
    e.stopPropagation();
    setBackLoaded(null);
    setBackPreview(null);
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();

    if (!frontLoaded || !backLoaded) {
      setStatusModal({
        show: true,
        title: "Missing Documents",
        message: "Please upload both front and back photos of the Aadhar card.",
        isSuccess: false,
      });
      return;
    }

    if (aadharProcess.current) {
      return;
    }

    setProcess(true);
    aadharProcess.current = true;

    const formData = new FormData();
    formData.append("Name", Name.trim());
    formData.append("Email", Email.trim());
    formData.append("userid", userid.trim());
    formData.append("Number", Number.trim());
    formData.append("DOB", DOB);
    formData.append("front", frontLoaded);
    formData.append("back", backLoaded);

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `admin/aadharcard-admin-kyc`,
        "POST",
        formData,
        headers,
      );

      if (res?.data?.status === false) {
        setStatusModal({
          show: true,
          title: "Submission Failed",
          message: res?.data?.msg || "Could not process KYC.",
          isSuccess: false,
        });
      } else if (res?.data?.msg === false) {
        setStatusModal({
          show: true,
          title: "Duplicate Entity",
          message: "This Aadhar card number is already registered.",
          isSuccess: false,
        });
      } else {
        setStatusModal({
          show: true,
          title: "KYC Verified Successfully",
          message:
            "The user's Aadhar KYC has been manually submitted & verified.",
          isSuccess: true,
        });
      }
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      } else {
        setStatusModal({
          show: true,
          title: "Error",
          message:
            err?.response?.data?.msg ||
            err?.response?.data?.message ||
            "An error occurred while submitting KYC. Please try again.",
          isSuccess: false,
        });
      }
    } finally {
      aadharProcess.current = false;
      setProcess(false);
    }
  };

  return (
    <div className="py-3">
      {/* Header */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <div>
          <h3 className="dashboard_heading mb-1 text-dark font-weight-bold">
            <i className="mdi mdi-card-account-details text-primary mr-2"></i>
            Manual User KYC Verification
          </h3>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            Direct administrative submission and verification of player Aadhar
            documents.
          </p>
        </div>
        <Link to="/user/kyc" className="btn btn-sm btn-secondary mt-2 mt-sm-0">
          <i className="mdi mdi-arrow-left mr-1"></i> Back to KYC List
        </Link>
      </div>

      <div className="row">
        <div className="col-xl-9 col-lg-11">
          <div
            className="card border-0 shadow-sm"
            style={{ borderRadius: "12px" }}
          >
            <div className="card-body p-4 p-md-5">
              <form onSubmit={handleSubmitData}>
                {/* SECTION 1: USER DETAILS */}
                <h5 className="font-weight-bold text-dark mb-3 d-flex align-items-center">
                  <span
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      backgroundColor: "#e0e7ff",
                      color: "#3730a3",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      marginRight: "10px",
                    }}
                  >
                    1
                  </span>
                  Player Identity Information
                </h5>

                <div className="row mb-4">
                  <div className="col-md-6 mb-3">
                    <label className="font-weight-bold text-dark mb-1">
                      User ID <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text bg-white"
                          style={{ borderRadius: "8px 0 0 8px" }}
                        >
                          <i className="mdi mdi-identifier text-muted"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control new_radius"
                        placeholder="Mongo ID or User ID"
                        value={userid}
                        onChange={(e) => setUserId(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="font-weight-bold text-dark mb-1">
                      Full Name (as on Aadhar){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text bg-white"
                          style={{ borderRadius: "8px 0 0 8px" }}
                        >
                          <i className="mdi mdi-account text-muted"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control new_radius"
                        placeholder="Full Legal Name"
                        value={Name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="font-weight-bold text-dark mb-1">
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text bg-white"
                          style={{ borderRadius: "8px 0 0 8px" }}
                        >
                          <i className="mdi mdi-email text-muted"></i>
                        </span>
                      </div>
                      <input
                        type="email"
                        className="form-control new_radius"
                        placeholder="user@example.com"
                        value={Email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="font-weight-bold text-dark mb-1">
                      Date of Birth <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={DOB}
                      onChange={(e) => setDob(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="font-weight-bold text-dark mb-1">
                      Aadhar Number (12 digits){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text bg-white"
                          style={{ borderRadius: "8px 0 0 8px" }}
                        >
                          <i className="mdi mdi-numeric text-muted"></i>
                        </span>
                      </div>
                      <input
                        type="tel"
                        maxLength={12}
                        className="form-control font-mono"
                        placeholder="12-digit number"
                        value={Number}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          setNumber(val);
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>

                <hr className="my-4" style={{ borderColor: "#f1f5f9" }} />

                {/* SECTION 2: DOCUMENT UPLOADS */}
                <h5 className="font-weight-bold text-dark mb-3 d-flex align-items-center">
                  <span
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      backgroundColor: "#dcfce7",
                      color: "#166534",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      marginRight: "10px",
                    }}
                  >
                    2
                  </span>
                  Aadhar Card Photos
                </h5>

                <div className="row mb-4">
                  {/* Front Photo */}
                  <div className="col-md-6 mb-3">
                    <label className="font-weight-bold text-dark mb-2">
                      Front Photo <span className="text-danger">*</span>
                    </label>
                    <div
                      style={{
                        border: "2px dashed #cbd5e1",
                        borderRadius: "12px",
                        backgroundColor: "#f8fafc",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() =>
                        document.getElementById("adminFrontPhoto").click()
                      }
                      className="hover-shadow"
                    >
                      <input
                        id="adminFrontPhoto"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFrontPhotoChange}
                      />

                      {frontPreview ? (
                        <div>
                          <img
                            src={frontPreview}
                            alt="Front Preview"
                            style={{
                              maxHeight: "140px",
                              borderRadius: "8px",
                              objectFit: "cover",
                              marginBottom: "10px",
                              border: "1px solid #e2e8f0",
                            }}
                          />
                          <div className="d-flex align-items-center justify-content-center">
                            <span
                              className="font-weight-bold text-dark mr-2"
                              style={{ fontSize: "12px" }}
                            >
                              {frontLoaded?.name}
                            </span>
                            <button
                              type="button"
                              className="btn btn-xs btn-outline-danger"
                              onClick={removeFrontPhoto}
                            >
                              <i className="mdi mdi-close"></i> Remove
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="py-3">
                          <i
                            className="mdi mdi-cloud-upload-outline text-primary mb-2"
                            style={{ fontSize: "40px", display: "block" }}
                          ></i>
                          <strong className="text-dark d-block">
                            Upload Front Photo
                          </strong>
                          <small className="text-muted">
                            PNG, JPG, or WEBP up to 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Back Photo */}
                  <div className="col-md-6 mb-3">
                    <label className="font-weight-bold text-dark mb-2">
                      Back Photo <span className="text-danger">*</span>
                    </label>
                    <div
                      style={{
                        border: "2px dashed #cbd5e1",
                        borderRadius: "12px",
                        backgroundColor: "#f8fafc",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() =>
                        document.getElementById("adminBackPhoto").click()
                      }
                    >
                      <input
                        id="adminBackPhoto"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleBackPhotoChange}
                      />

                      {backPreview ? (
                        <div>
                          <img
                            src={backPreview}
                            alt="Back Preview"
                            style={{
                              maxHeight: "140px",
                              borderRadius: "8px",
                              objectFit: "cover",
                              marginBottom: "10px",
                              border: "1px solid #e2e8f0",
                            }}
                          />
                          <div className="d-flex align-items-center justify-content-center">
                            <span
                              className="font-weight-bold text-dark mr-2"
                              style={{ fontSize: "12px" }}
                            >
                              {backLoaded?.name}
                            </span>
                            <button
                              type="button"
                              className="btn btn-xs btn-outline-danger"
                              onClick={removeBackPhoto}
                            >
                              <i className="mdi mdi-close"></i> Remove
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="py-3">
                          <i
                            className="mdi mdi-cloud-upload-outline text-success mb-2"
                            style={{ fontSize: "40px", display: "block" }}
                          ></i>
                          <strong className="text-dark d-block">
                            Upload Back Photo
                          </strong>
                          <small className="text-muted">
                            PNG, JPG, or WEBP up to 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <hr className="my-4" style={{ borderColor: "#f1f5f9" }} />

                {/* SUBMIT BUTTON */}
                <div className="d-flex justify-content-end align-items-center gap-2">
                  <Link to="/user/kyc" className="btn btn-secondary mr-2">
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    disabled={submitProcess}
                  >
                    {submitProcess ? (
                      "Verifying KYC..."
                    ) : (
                      <>
                        <i className="mdi mdi-check-decagram mr-1"></i> Submit &
                        Verify KYC
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* FEEDBACK MODAL */}
      <Modal
        show={statusModal.show}
        onHide={() => {
          setStatusModal({ ...statusModal, show: false });
          if (statusModal.isSuccess) {
            history.push("/user/kyc");
          }
        }}
        centered
        size="sm"
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #e2e8f0" }}>
          <Modal.Title
            className={`h6 font-weight-bold m-0 ${
              statusModal.isSuccess ? "text-success" : "text-danger"
            }`}
          >
            <i
              className={`mdi ${
                statusModal.isSuccess ? "mdi-check-circle" : "mdi-alert-circle"
              } mr-1`}
            ></i>
            {statusModal.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4 bg-white">
          <i
            className={`mdi ${
              statusModal.isSuccess
                ? "mdi-check-circle-outline text-success"
                : "mdi-alert-circle-outline text-danger"
            } mb-2 d-block`}
            style={{ fontSize: "44px" }}
          ></i>
          <p className="mb-0 text-dark font-weight-medium">
            {statusModal.message}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center p-2 bg-light">
          <Button
            variant={statusModal.isSuccess ? "success" : "danger"}
            size="sm"
            className="px-4"
            onClick={() => {
              setStatusModal({ ...statusModal, show: false });
              if (statusModal.isSuccess) {
                history.push("/user/kyc");
              }
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminKyc;
